import { type UserWithId } from '@/lib/types';
import { createContext } from 'react';

const UserContext = createContext<UserWithId>(null as unknown as UserWithId);

export default UserContext;
